export function getSelValueChar(value) {
    switch(value) {
        // Modalita'
        case "Contanti": return 'C';
        case "POS": return 'P';
        case "Assegno": return 'A';
        case "Bonifico": return 'B';
        case "Altro": return 'X';    

        // Trattenimento
        case "Sì": return 'T';         
        case "No": return 'F';
            
        default: return "";
    }         
}

export function getSelValueEsteso(value) { 
    switch(value) {
        // Modalita'
        case 'C': return "Contanti";
        case 'P': return "POS";
        case 'A': return "Assegno";
        case 'B': return "Bonifico";
        case 'X': return "Altro";    

        // Trattenimento
        case 'T': return "Sì";         
        case 'F': return "No";
            
        default: return "";
    }          
}

export function getSelValueProvenienzaClienteEsteso(value) {
    switch(value) {
        case 'A': return "Visita cliente";
        case 'B': return "Visita buono soggiorno";
        case 'S': return "Visita sito Imperial";
        case 'E': return "Evento associativo";
        case 'R': return "Rinfresco";

        default: return "";
    }
}



// WEBPACK FOOTER //
// ./src/cmp/Orders/UtilOrder.js